export default {
  OPEN_INCIDENTS_RESOLVED: "OPEN_INCIDENTS_RESOLVED",
  OPEN_INCIDENTS: "OPEN_INCIDENTS"
};
